import { render } from "./QueryTypeMaster.vue?vue&type=template&id=c0f710dc&scoped=true"
import script from "./QueryTypeMaster.vue?vue&type=script&lang=js"
export * from "./QueryTypeMaster.vue?vue&type=script&lang=js"

import "./QueryTypeMaster.vue?vue&type=style&index=0&id=c0f710dc&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f710dc"]])

export default __exports__